module.exports =  {
  TITLE: {
       default: 'Zoek Hotel|Tienduizenden hotels in Azië online te reserveren',
    detail: '|Hotelreservering',
  },
  hotel: {
    // Hotel zoeken herziene toevoeging van vertaling - Engels
    ROOMS: 'Kamers',
    GUESTS: 'Gasten',
    CHECK_IN_NUM: 'Gasten',
    PREFIX_ADULTS: '',
    SUFFIX_ADULT: 'Volwassene',
    SUFFIX_ADULTS: 'Volwassenen',
    PREFIX_CHILDREN: '',
    SUFFIX_CHILD: 'Kind',
    SUFFIX_CHILDREN: 'Kinderen',
    CHILD_AGE: 'Leeftijd van het kind',
    NO_MATCH_TIPS: 'Het onderstaande kamertype komt niet overeen met het aantal kamers en gasten dat u hebt geselecteerd.',

    Book_Hotel: 'Hotel Boeken',
    Select_your_destination: 'Selecteer uw bestemming',
    Please_enter_your_destination: 'Voer uw bestemming/hotel in',
    Booked_up: 'Volgeboekt',
    Hotel_description: 'Hotelbeschrijving',
    Check_in_date: 'Incheckdatum',
    Check_out_date: 'Uitcheckdatum',
    Sold_out: 'Uitverkocht',
    Non_refundable: 'Niet-restitueerbaar',
    reserve: 'Boek',
    Pay_Online: 'Betaal Online',
    Only_rooms_left_before: 'Slechts ',
    Only_rooms_left_after: ' kamer(s) over',
    Cancellation_Policy: 'Annuleringsbeleid',
    See_all_prices_before: 'Zie alle ',
    See_all_prices_after: 'prijzen',
    Estimated_time_of_arrival: 'Geschatte aankomsttijd',
    make_your_schedule_well_planned: 'De tijd is voor de lokale tijdzone, zorg ervoor dat uw schema goed gepland is en kom op tijd aan.',
    Hotel_Not_Found: 'Hotel Niet Gevonden',
    Please_change_your_search: 'Wijzig uw zoekopdracht',
    Submit_an_application: 'Dien een aanvraag in',
    Hotel_Confirmation: 'Hotelbevestiging',
    Many_Night_Stay_before: '',
    Many_Night_Stay_after: '-Nacht Verblijf',
    Hotel_Booking_Number: 'Hotel Boekingsnummer',
    Online_Payment: 'Online Betaling',
    The_guest_Room_before: 'De gast[Kamer',
    The_guest_Room_after: ']',
    Contact_number: 'Contactnummer',
    Bring_all_valid_IDs: 'Breng alle geldige ID\'s van alle gasten mee bij het inchecken.',
    Hotels_Found_before: '',
    Hotels_Found_after: 'Hotels Gevonden',
    Hotels_Presented_before: '',
    Hotels_Presented_center: 'Gepresenteerde Hotels (',
    Hotels_Presented_after: ' in totaal)',
    Please_change_the_dates: 'Kamer niet beschikbaar op uw data, gelieve de data te wijzigen.',
    Login: 'Log in op de APP om een hotel te boeken',
    Nights_in_total_before: '',
    Nights_in_total_after: 'Nachten in totaal',
    Location: 'Locatie',
    Pictures: 'Afbeeldingen',
    Description: 'Beschrijving',
    Policy: 'Beleid',
    Check_in_and_check_out_time: 'Incheck- en uitchecktijd',
    Check_in_and_Check_out_before: 'Inchecken: na ',
    Check_in_and_Check_out_center: 'Uitchecken: voor ',
    Check_in_and_Check_out_after: '',
    Check_in_time: 'Inchecken',
    Check_out_time: 'Uitchecken',
    Hotel_Information: 'Basis informatie',
    Opening_Date: 'Openingsdatum',
    Renovation_Date: 'Renovatie datum',
    Facility_Service: 'Faciliteit & Service',
    Payment_methods: 'Betaalmethoden geaccepteerd door het hotel',
    Hotel_Address: 'Hoteladres',
    Pay_online: 'Online betalen',
    Pay_offline: 'Offline betalen',
    Night_stay_before: '',
    Night_stay_after: '-Nacht Verblijf,',
    Rooms_total_before: 'Kamers',
    Rooms_total_after: 'in totaal',
    Guest_name_must_be_provided: 'De volledige gastennaam moet worden verstrekt.',
    Please_fill_in_your_contact_number: 'Vul uw contactnummer in',
    Select_estimated_time_of_arrival: 'Selecteer de geschatte aankomsttijd',
    Number_of_Rooms: 'Aantal kamers',
    Maximum_guests_per_room_before: 'Maximaal ',
    Maximum_guests_per_room_after: ' gasten per kamer',
    Many_Rooms: ' Kamers',
    Service_Fee_Included: '(Belasting & Servicekosten Inbegrepen)',
    Last_Name: 'Achternaam',
    First_Name: 'Voornaam ',
    Room: 'Kamer',
    Additional_Tax: 'Extra belasting',
    Please_inform_the_hotel: 'Als u later dan de geschatte aankomsttijd aankomt, informeer dan het hotel van tevoren.',
    Please_inform_the_hotel_first: 'Aankomst in het hotel na de geschatte aankomsttijd zonder contact op te nemen met het hotel van tevoren, heeft invloed op de beschikbaarheid van de kamer en het diner. Informeer eerst het hotel om de beschikbaarheid in dergelijke omstandigheden te bevestigen.',
    Booking_Cancellation: 'Annulering van de boeking',
    Reason_of_Cancellation: 'Reden van annulering',
    Incorrect_Information_Filled: 'Onjuiste informatie ingevuld',
    Itinerary_Changed: 'Reisschema gewijzigd',
    Lower_price_on_other_APP: 'Lagere prijs op andere APP',
    Low_quality_hotel: 'Hotel van lage kwaliteit',
    Book_at_a_lower_price: 'Boek tegen een lagere prijs bij de receptie',
    Other: 'Overig',
    Please_write_your_reason: 'Schrijf uw reden op',
    After_cancellation_done: 'Na annulering wordt de betaling binnen 3 werkdagen teruggestort naar de oorspronkelijke betaler.',
    How_to_fill_in_the_guest_name: 'Hoe de gastennaam in te vullen',
    It_should_be_exactly_the_same: 'Geef de gastennaam op in het Engels voor de hotelreservering. Het moet exact overeenkomen met het certificaat dat wordt getoond bij het inchecken.',
    How_to_fill_in_a_Chinese_name: 'Hoe een Chinese naam in te vullen:',
    How_to_fill_in_a_English_name: 'Hoe een Engelse naam in te vullen',
    For_example: 'Bijvoorbeeld: Als uw Chinese naam "韩梅梅" is, is de achternaam "Han" en de voornaam "Meimei".',
    No_specical_characters: 'Vul geen cijfers of speciale tekens in. ',
    Name_rule_first: 'De achternaam komt eerst, gevolgd door de voornaam, en als er een middelste naam is, wordt er een spatie achter de twee namen geplaatst. ',
    Name_rule_second: 'Bijvoorbeeld: Green / Jim Stephanie',
    Details: 'Details',
    Pay_now: 'Nu betalen',
    Hotel: 'Hotel',
    Check_in: 'Inchecken',
    Car: 'Auto',
    All_bookings: 'Alle boekingen',
    All: 'Alles',
    PROMPT: 'Let op',
    Search: 'Zoeken',
    COST_DESCRIPTION: 'Prijsdetail',
    TOTAL: 'Totaal',
    SEE_ORDER_INFO_TO: 'Betalen',
    KONW: 'Begrepen',
    BOOKING_INFORMATION: 'Belangrijke informatie',
    Book_Now: 'Nu betalen',
    MAP: 'Kaart',
    CONTACT_INFORMATION: 'Contactinformatie',
    LOADING: 'Bezig met laden...',
    SORT_FILTER: 'Sorteren/Filteren',
    SCREENING: 'Filter',
    SEQUENCE: 'Sorteren',
    PHONE_ASK: 'Bel ons',
    ABOVE: '',
    SUBMINT_ORDER: 'Indienen',
    OK: 'OK',
    Order_detail: 'Bestelgegevens',
    BOOKING_INFO: 'Boekingsinformatie',
    PAYMENT_AMOUNT: 'Betaalbedrag',
    Order_time: 'Tijd van boeking',
    ORDER_NUMBERS: 'Boekingsnummer',
    PAY_TYPE: 'Betaalmethode',
    BALANCE: 'Balans',
    CURRENT_BALANCE_BEGIN: 'Huidige balans',
    OVERPLUS_BALANCE_BEGIN: 'Resterend',
    OTHER_PAYMENT: 'Andere betaalmethoden',
    Unionpay: 'UnionPay',
    Wechatpay: 'WeChat-betaling',
    Alipay: 'Alipay',
    AGREE_SERVICE_AGREEMENT_BEFORE: 'Door op "Nu betalen" te klikken, betekent dat u akkoord gaat met Baigolf ',
    AGREE_SERVICE_AGREEMENT_AFTER: '',
    SERVICE_AGREEMENT: '《Serviceovereenkomst》',
    PAYMENT_ORDER: 'Boekingsbetaling',
    Total_pay: 'Te betalen bedrag',
    PAY_SUCCESS: 'Betaling geaccepteerd',
    CHECK_THE_ORDER: 'Controleer de bestelling',
    BACK_TO_INDEX: 'Terug naar Index',
    CANCEL: 'Annuleren',
    RECOMMED: 'Aanbevelen',
    PRICE: 'Prijs',
    HIGH: 'Hoog',
    LOW: 'Laag',
    RESET: 'Herstellen',
    SELECT_TIME: 'Selecteer datum',
    Hotel_guest: 'De gast',
    Select: 'Selecteer alstublieft',
    Emial_address: 'Voer alstublieft het e-mailadres in',
    Booking_explan: 'Boekingsinformatie',
    VIEW_MORE: 'Bekijk meer',
    COLLAPSE: 'Verbergen',
    Week: '',
    Month: '',
    TOURISM_CHECK_IN_HOTEL: 'Inchecken',
    TOURISM_LEAVE_HOTEL: 'Uitchecken',
    arrive: 'Bestemming',
    Room_description: 'Kamerbeschrijving',
    Meals: 'Maaltijden',
    Room_Type: 'Kamertype',
    BOOKING_EXPLANATION: 'Boekingsinformatie',
    BOOKING_BUTTON: 'Boek',
    REMIND_SUBMIT_ORDER: 'Doorgaan',
    login_now: 'Voor hotelreserveringen moet u inloggen, nu inloggen?',
    the_real_scene: 'Afbeeldingen zijn slechts ter referentie en onderhevig aan de werkelijke situatie.',
    Bed: 'Bed',
    Rooms: 'Kamer',
    Room_rate: 'Kamertarief',
    notified_by_SMS: 'Na succesvolle reservering wordt u op de hoogte gesteld via sms',
    email_notifications: 'Gebruikt voor het ontvangen van e-mailmeldingen',
    Booking_deadline: 'Uiterste boekingsdatum',
    Child: 'Kind',
    Additional_notes_about_payment: 'Aanvullende opmerkingen over de betaling',
    Nights: 'Nachten',
    Minimum_nights_before: 'Minimaal',
    Minimum_nights_after: 'nachten',
    Size: 'Grootte',
    Guests: 'Gasten',
    Room_rate_1: 'Kamertarief',
    Tax_service_fee: 'Belasting/servicekosten',
    Pay_now_1: 'Nu betalen',
    Filter: 'Filter',
    Room_rate2: 'Kamertarief',
    Show_on_map: 'Tonen op kaart',
    Detail: 'Detail',
    Room_Detail: 'Detail',

    TAXES_INCL: 'Belastingen incl.',
    SEARCH_EMPTY_TIP: 'Sorry, geen beschikbaarheid op de door u gekozen datum, u kunt: alternatieve data of hotels zoeken',
    severalNight: 'Nachten',
    immediateBooking: 'Nu boeken',
    Refundable: 'Restitueerbaar',
    MORE: 'Meer',
    adultsCompany: 'volwassenen',
    ServiceTerms: 'Diensten & Voorwaarden',
    roomPlan: 'Plan',
    guestRoom: 'Kamer',
    searchAgain: 'Opnieuw zoeken',
    roomNight: 'kamer/nacht',

    NAME_TXT: 'Naam',
    HOLDER_NAME: 'Naam kaarthouder',
    EXPIRATION_DATE: 'Vervaldatum',
    FORMAT_TXT: 'Formaat',
    SECURITY_CODE: 'Veiligheidscode',
    MASTER_CARD_NAME: 'Mastercard',
    JCB_CARD_NAME: 'JCB',
    DIGITS_ON_BACK_OF_CARD: 'De 3 cijfers op de achterkant van de kaart.',
    AMERICAN_EXPRESS_NAME: 'American Express',
    FOUR_CAR_NUM_TIPS: '4 cijfers aan de voorkant van de kaart',
    ENTER_COMPLETE_CARD_NUM: 'Voer een volledig kaartnummer in.',
    PLEASE_ENTER_HOLDER_NAME: 'Voer de naam van de kaarthouder in',
    ENTER_SECURITY_CODE: 'Voer de beveiligingscode in',
    ENTER_EXPIRATION_DATE: 'Voer de vervaldatum in',
    ROOM_DETAILS: 'Kamerdetails',
    CONDITION_CANCEL: 'Restitueerbaar',
    CHOOSE_PAYMENT_METHOD: 'Betaling',
    ORDER_TOTAL_LUMP: 'Totaalbedrag',
    CREDIT_CARD_NUM: 'Debit-/Creditcardnummer',
    MAINLAND_CARD_ONLY: 'Alleen bankpas uitgegeven buiten het Chinese vasteland.',
    SHUT_DOWN: 'Sluiten',
    PROVIDER_FROM_CHINA_BANK: 'Betalingsdienst geleverd door B.O.C',
        COUPON: 'Coupon',
    APPLY_A_COUPON: 'Gebruik een coupon',
    NO_USE: 'Niet van toepassing op deze deal.',
    Discard: 'Afwijzen',
    REDEEM: 'Inlossen',
    EMPTY_COUPON: 'Voer alstublieft de promotiecode in',
    NOTICE_COUPON: 'Slechts één coupon kan worden ingewisseld voor elke boeking; de coupon wordt ingewisseld nadat de boeking is ingediend.',

    BREAKFAST_INCLUDE: 'inclusief ontbijt',
    BREAKFAST_EXCLUDE: 'exclusief ontbijt',
    DOUBLE_BED: 'tweepersoonsbed',
    TWIN_BED: 'twee aparte bedden',
    FREE_CANCEL: 'gratis annulering',
    MEALS: 'maaltijden',
    EVALUATION: 'Beoordeling',
    FEATURED_REVIEWS: 'Uitgelichte beoordelingen',
    ALL_REVIEWS: 'Alle beoordelingen',
    OVERALL_EVALUATION: 'Algemene beoordeling',
    ANONYMOUS: 'Anoniem',
    EVAL_GENERAL_LIST_1: 'Slecht',
    EVAL_GENERAL_LIST_2: 'Redelijk',
    EVAL_GENERAL_LIST_3: 'Gemiddeld',
    EVAL_GENERAL_LIST_4: 'Goed',
    EVAL_GENERAL_LIST_5: 'Uitstekend',
    MAX_IMAGES_WITH_NINE: 'Er kunnen maximaal 9 foto\'s worden geselecteerd.',
    GRADE_EVAL: 'Selecteer alstublieft de algemene beoordeling',
    DISTANCE_FILTER: 'afstand dichtbij-ver',
    EDIT_EVALUATION: 'geef commentaar',
    GO_TO_EVAL: 'geef commentaar',
    EVAL_POINTS_AWARD: 'Goede opmerkingen kunnen 1000 punten winnen, 1000 punten = 10 RMB',
    NEARBY_LIKE_HOTEL: 'vergelijkbaar hotel in de buurt',
    DISTANCE_HOTEL: 'naar hotel',
    PLEASE_ENTER_COMMENT: 'opmerkingen',
    AWARD_POINTS_TIPS: 'De beste opmerkingen kunnen 1000 punten krijgen, 1000 = 10 RMB',
    NO_SHOW_ANONYMOUS_AVATAR: 'Anonieme opmerkingen tonen uw logo en naam niet',
    LOCATION: 'locatie',
    FACILITY: 'faciliteit',
    SERVICE: 'service',
    HEALTH: 'schoon',
    LANGUAGE_SELECT: 'taal',
    LIMIT_COMMENT_TXT: 'Beoordeling moet 5~2000 tekens hebben',
    SHARE_MEDIA: 'Deel foto\'s en video',
    SETTLEMENT_FEEL: 'Opmerkingen',
    SUBMIT_EVAL: 'Bevestigen',
    HOTEL_STR: 'Details',
    EVAL_NUM_AFTER: 'beoordeling',
  },
  header: {
    SKIING: 'Ski-oord',
    header_internal_call: 'Vasteland China:',
    header_abroad_call: 'Internationaal:',
    header_app_download: 'Mobiele App',
    service_telephone: 'Klantenservice',
    account_number: 'Account',
    if_bg_user: 'Geen lid van BaiGolf?',
    home: 'Home',
    hotel: 'Hotel',
    Golf: 'Golf',
    PLAY_STAY: 'Verblijf & Speel',
    RENT_CAR_HOME: 'Auto',
    center_user: 'Ledencentrum',
    header_my_order: 'Mijn boekingen',
    header_notmember_order: 'Gastboekingen',
    header_edit_password: 'Wachtwoord wijzigen',
    header_logout: 'Uitloggen',
    header_login: 'Inloggen',
    header_register: 'Registreren',
    header_point: 'Mijn punten',
    header_all_language: 'Alle talen',
    down_load_app: 'Scan QR-code om te downloaden',
    login_discount_tip: 'Log in om bonus te verdienen en te genieten van exclusieve voordelen',
    currency_balance_limit: 'De huidige valuta heeft nog een saldo, kan niet wisselen van valuta'
  },
  footer: {
    footer_partner: 'Partners',
    footer_about_us: 'Over ons',
    footer_about_baigolf: 'Over BaiGolf.com',
    footer_privacy_policy: 'BaiGolf.com Privacybeleid',
    footer_use_of_terms: 'BaiGolf.com Servicevoorwaarden',
    footer_contact_us: 'Contacteer ons',
    footer_sitemap: 'Sitemap',
    footer_use_of_question: 'FAQ',
    footer_ios_system: 'iOS',
    footer_android_system: 'Android',
    footer_app_load: 'APP Downloaden',
    footer_sina_weibo: 'Sina Weibo',
    footer_tencent_weibo: 'Tencent microblog',
    footer_share_to: 'Delen',
    copyright1: 'Guangzhou BaiGolf Information Technology Co., Ltd. Auteursrecht ',
    copyright2: 'Yue ICP-registratienummer 14070002',
    news_center: 'Nieuwscentrum',
    about_baigolf: 'Over BaiGolf',
    help: 'Help',
    management_system: 'BG Golf Management System (BGMS)',
    wechat_official_account: 'WeChat Officieel Account',
    download_baiGolf_app: 'BaiGolf App Downloaden',
    privacy_policy: 'Privacybeleid',
    use_of_terms: 'Servicevoorwaarden',
    footer_integral: 'Puntenbeleid',
    footer_reserve: 'Boekingsbeleid',
    footer_abroad_call: 'Internationaal',
    footer_internal_call: 'Vasteland China'


  }
}



// WEBPACK FOOTER //
// ./src/lang/dutch.js